
let currentProduct;
let currentMode = null;
const customer = 'ADANDCOAU';

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};

const getCurrentSKU = (overrideSize = null) => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== "").pop();
    const productParts = product.split("?");

    const currentProduct = productParts[0].toLowerCase(); // e.g. drum-side-table
    let finalSKU = currentProduct;

    const selects = document.querySelectorAll('select.dynamic-variant-input');

    const optionValues = Array.from(selects).map(select => {
        const selectedOption = select.options[select.selectedIndex];
        return selectedOption?.value?.toLowerCase().replace(/\s+/g, "-") || null;
    }).filter(Boolean);

    // override first value with manual size
    if (overrideSize) {
        optionValues[0] = overrideSize.toLowerCase().replace(/\s+/g, "-");
    }

    if (optionValues.length) {
        finalSKU += "-" + optionValues.join("-");
    }

    finalSKU = finalSKU.replace(/[()]/g, "");


    console.log("Final SKU:", finalSKU);
    return finalSKU;
};



const initializeMazing = async () => {
    const productMediaElements = document.querySelectorAll('.product__media');

    if (productMediaElements.length > 1) {
        productMediaElements[1].classList.add('my-placement-target');
    }


    await mazing({
        customerName: customer,
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container {
                    width: 100%;
                    display: flex;
                    margin-top: 10px;
                    position: absolute;
                    bottom: 10px;
                    justify-content: end;
                    z-index: -10;
                }
                
                .mazing-ar-btn-icon,
                .mazing-threed-btn-icon {
                    filter: invert(100%) brightness(1000%);
                    width: fit-content !important;
                    margin-right: 6px;
                }
                
                .mazing-threed-btn,
                .mazing-ar-btn { 
                    box-shadow: none !important;
                    display: flex !important;
                    justify-content: center;
                    gap: 10px !important;
                    margin-right: 24px !important; 
                }

                .mazing-threed-btn-text,
                .mazing-ar-btn-text{
                    color: #fff
                }

                .mazing-visible {
                    z-index: 1 !important;
                }
                                
                @media (max-width: 960px) {
                    .mazing-button-container {
                        justify-content: center !important;
                        bottom: -6px !important;
                    }
                    
                    .mazing-threed-btn,
                    .mazing-ar-btn { 
                        margin-right: 0 !important; 
                    } 
                }
                
            `,
            placementSelector: '.my-placement-target .product__media-item',
            threedBtn: {
                enabled: true,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in 3D",
                        "de": "In 3D ansehen",
                        "fr": "Voir en 3D",
                        "es": "Ver en 3D"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            },
            arBtn: {
                enabled: false,
                icon: false,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in Room",
                        "de": "Im Raum anzeigen",
                        "fr": "Voir dans votre espace",
                        "es": "Ver en tu espacio"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            }
        },
        getSKU: getCurrentSKU
    });

    console.log('Mazing initialized.');
};

const initializeSizesListener = async () => {
    const sizesContainer = await waitForElement('#size');

    if (sizesContainer) {
        sizesContainer.removeEventListener('change', handleSizeClick);
        sizesContainer.addEventListener('change', handleSizeClick);

        console.log('Size listener initialized.');
    }
};

const handleSizeClick = async (event) => {
    const selectedOption = event.target.value || null;
    if (selectedOption) {
        setTimeout(async () => {
            const newSKU = getCurrentSKU(selectedOption.toLowerCase());
            await mazingRefreshSKU(newSKU, customer);
        }, 100);
    }
};

const addClassesToMazingButton = async () => {
    const threedBtn = document.getElementById('mazing-threed-btn');
    const btnContainer = document.querySelector('.mazing-button-container');

    if (threedBtn) {
        threedBtn.classList.add(
            'product-form__cart-submit', 'btn', 'btn--medium', 'btn--primary'
        );
    }

    setTimeout(() => {
      if (btnContainer) {
        btnContainer.classList.add('mazing-visible');
      }  
    }, 1800)
};

const clearOldTargetClasses = () => {
    document.querySelectorAll('.product__media').forEach(el => {
        el.classList.remove('my-placement-target');
    });
};

const determineAndSetPlacement = () => {
    const productMediaElements = document.querySelectorAll('.product__media');
    const isMobile = window.innerWidth < 960;

    clearOldTargetClasses();

    if (isMobile) {
        if (productMediaElements[0]) {
            productMediaElements[0].classList.add('my-placement-target');
            currentMode = 'mobile';
        }
    } else {
        if (productMediaElements[1]) {
            productMediaElements[1].classList.add('my-placement-target');
            currentMode = 'desktop';
        }
    }
};

const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        determineAndSetPlacement();

        document.querySelectorAll('.mazing-button-container').forEach(btn => btn.remove());
        document.querySelectorAll('#mazing-popup-container').forEach(popup => popup.remove());

        await initializeMazing();
        await addClassesToMazingButton();

        // await initializeSizesListener();
        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    }
};

// There are two different galleries for desktop and mobile. We re-init whenever currentMode is changing
let resizeTimeout;
window.addEventListener('resize', () => {
    const isNowMobile = window.innerWidth < 960;
    const newMode = isNowMobile ? 'mobile' : 'desktop';

    if (newMode !== currentMode) {
        // debounce resize events
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            console.log('Reinitializing for new mode:', newMode);
            initializeScript();
        }, 100);
    }
});

initializeScript();
